import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  testimonials: localStorage.getItem('resources') && JSON.parse(localStorage.getItem('resources'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/resources/index.js